import { Component, OnDestroy, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ContractsCommonService } from '../../service/contract-creation/contracts-common.service';
import { CompanyResponse } from '../../../shared/lib/model/common';
import { Subscription } from 'rxjs';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-company-info',
  templateUrl: './company-info.component.html',
  styleUrls: ['./company-info.component.scss'],
  standalone: false
})
export class CompanyInfoComponent implements OnDestroy {
  @ViewChild('companyTable') companyTable!: Table;
  
  visible: boolean = false;
  companiesDetails: any;
  searchTerm: string = '';
  companySubscription: Subscription;
  constructor(private contractCommonService: ContractsCommonService, private messageService: MessageService) {
    this.companySubscription = this.contractCommonService.getAllCompanies().subscribe({
      next: (data: CompanyResponse) => {
        this.companiesDetails = data.data;
      },
      error: (error) => {
        console.error('Error fetching companies:', error);
      },
      complete: () => { }
    });
  }

  copyToClipboard(value: string): void {
    navigator.clipboard.writeText(value).then(() => {
      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Copied to clipboard: ' + value
      });
    }).catch(err => {
      console.error('Error copying text: ', err);
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Failed to copy text.'
      });
    });
  }

  downloadTableData(): void {
    const csvData = this.convertToCSV(this.companiesDetails);
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', 'company_details.csv');
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  private convertToCSV(data: any[]): string {
    if (!data || !data.length) {
      return '';
    }

    const headers = ['Company Code', 'Company Name'];
    const rows = data.map(row => [
      row.companyCode,
      this.escapeCSVValue(row.companyName)
    ]);

    const csvRows = rows.map(row => row.join(','));
    return [headers.join(','), ...csvRows].join('\n');
  }

  private escapeCSVValue(value: string): string {
    if (value === null || value === undefined) {
      return '';
    }
    if (value.includes(',') || value.includes('"') || value.includes('\n')) {
      return `"${value.replace(/"/g, '""')}"`;
    }
    return value;
  }

  resetFilters(): void {
    this.searchTerm = '';
    if (this.companyTable) {
      this.companyTable.clear();
      this.companyTable.filterGlobal(this.searchTerm, 'contains');
      this.companyTable.reset();
      this.companyTable.rows = 10;
    }
  }

  ngOnDestroy(): void {
    if (this.companySubscription) {
      this.companySubscription.unsubscribe();
    }
  }
}